import React from "react";
import {push} from 'react-router-redux';
import {store} from '../../store/store';
import { PullToRefresh, WhiteSpace, Tabs, List } from 'antd-mobile';
import MobileWrapper from '../../layouts/MobileWrapper';
import AnnouncementService from '../../services/Employee/announcement-service.js';
import ReactAbstract from "../../components/abstract/React.abstract";
import './style.css';
import { connect } from 'react-redux';
const tabs = [
  { title: '制度', key:"selectSystemAction" },
  { title: '公告', key:"selectAnnouncementAction" }
];

class MobileAnnouncement extends ReactAbstract {


    dataMode = 1

    state = {
        data: {
            Data: []
        },
        pageSize:0,
        cardListRefreshing: false,
        cardListHeight: document.documentElement.clientHeight,
        filters: {
            page: 1
        },
        tabIndex: "selectAnnouncementAction",
        currentModalStatus:false,
        complaint_content: ""
    }
    
    actions = {
        selectAction: AnnouncementService.fetchSystemAction,
        selectSystemAction: AnnouncementService.fetchSystemAction,
        selectAnnouncementAction: AnnouncementService.fetchAnnouncement 
    }

    changeTabIndex = value => this.setState({
        dataStatus: "unload",
        filters: {page: 1},
        tabIndex: value.key,
        data: {Data: []}
    }, () => {
        this.actions.selectAction = this.actions[value.key]
        this.publicChange();
    })

    publicSelect = callback => {
        let gets = {};
        Object.keys(this.state.filters).forEach(key => {
            if (this.state.filters[key]) {
                gets[key] = this.state.filters[key];
            }
        });
        let apoLoadStatus = false;
        if ("function" === typeof this.actions.selectAction) {
            this.actions.selectAction(gets, res => {
                apoLoadStatus = true;
                this.setState({
                    dataStatus: "loaded",
                    data: {
                        ...this.state.data,
                        ...res.data.Object,
                        Data: [
                            ...this.state.data.Data,
                            ...res.data.Object.Data
                        ]
                    }
                }, () => {
                    if ("function" === typeof callback) {
                        callback();
                    }
                })
            }, err => this.setState({dataStatus: "error"}))
            let timeoutIndex = setTimeout(() => {
                clearTimeout(timeoutIndex);
                if (!apoLoadStatus) {
                    this.setState({dataStatus: "loading"})
                }
            }, 100);
        }else{
            this.handleError("Child class's actions selectAction is required!");
        }       
    }

    pullFresh = () => {
        if (this.dataSource().data.Data.length < this.dataSource().data.Total) {
            this.setState({
                cardListRefreshing: true,
                filters: {
                    ...this.state.filters,
                    page: this.state.filters.page + 1
                }
            }, () => this.publicSelect(() => this.setState({
                cardListRefreshing: false
            })))
        }
        console.log(this.dataSource())
    }

    goToDetail = (params) => {
        var path = {
            pathname:'/mobile/mobile-announcement-detail',
            state:params,
        }

        store.dispatch(push(path))
    }

    render() {
        const self = this;
        const { currentUser } = this.props.user
        return (
            <div>
                <PullToRefresh
                    ref = {el => this.ptr = el}
                    style = {{
                        height: this.state.cardListHeight,
                        overflow: 'auto',
                    }}
                    direction = 'up'
                    refreshing = {this.state.cardListRefreshing}
                    onRefresh = {this.pullFresh} >
                    <WhiteSpace />
                    <Tabs tabs={tabs} 
                        initialPage={0}
                        animated={false}
                        useOnPan={false}
                        onChange={this.changeTabIndex} />
                    <WhiteSpace />

                    <div style={{clear: "both"}}></div>
                    {currentUser.PermissionDict.mobile_app_announcement.r_value &&
                    <List className="my-list">{this.dataSource().data.Data && 
                        this.dataSource().data.Data.map((apply, index) => (
                        <div key={index}>
                            <WhiteSpace size="lg"/>
                            <List.Item arrow="horizontal"  onClick={(e) => self.goToDetail(apply)}><span className="fa fa-circle-o" /> {apply.title}</List.Item>
                        </div>
                    ))}
                    <WhiteSpace />
                    {this.dataSource().data.Data.length >= this.dataSource().data.Total &&
                        <div style={{textAlign: "center"}}>没有更多数据了</div>
                    }
                    </List>}    
                    <WhiteSpace />
                </PullToRefresh>
            </div>
        )
    }
}

// export default MobileWrapper(MobileAnnouncement);
const mapStateToProps = state => {
    return {
        user: state.user
    }
}
const mapDispatchToProps = {
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileAnnouncement));




// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileAnnouncement.js